<template lang="">
    <div>
        <div class="box">
            <van-cell-group :border="false">
                <van-cell title="头像" class="avatar-wrap">
                    <div class="avatar">
                        <van-image
                            round
                            :src="userInfo.avatar"
                            :error-icon="require('@images/noavatar.png')"
                        ></van-image>
                    </div>
                </van-cell>
                <van-cell title="姓名" :value="userInfo.name" />
                <van-cell title="性别" :value="userInfo.sex" />
                <van-cell title="年龄" :value="userInfo.age" />
                <van-cell title="手机号" :value="userInfo.phone" />
                <van-cell title="单位" :value="userInfo.company" />
            </van-cell-group>
        </div>
    </div>
</template>
<script>
import { getUserProfile } from '@api/user';
export default {
    name: 'UserProfile',
    data() {
        return {
            userInfo: {
                avatar: '',
                name: '',
                sex: '',
                age: '',
                phone: '',
                company: ''
            }
        };
    },
    watch: {
        $route(n) {
            if (n.name === 'UserProfile') {
                this.getProfile();
            }
        }
    },
    created() {
        this.getProfile();
    },
    methods: {
        getProfile() {
            let that = this;
            getUserProfile()
                .then(res => {
                    that.$set(that, 'userInfo', res.data);
                })
                .catch(err => {
                    that.$dialog.error(err).then(() => {
                        that.$router.back();
                    });
                });
        }
    }
};
</script>
